export const Languages = ['de', 'en'];
export const Language =
	process.env.NODE_ENV === 'production' && document.documentElement
		? document.documentElement.lang
		: Languages[0];

export const NextLanguage = Languages.filter((l) => l !== Language)[0];
